import { combineReducers } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';

import {persistReducer} from "redux-persist";
import contractReducer from "./contractReducer";
import employeeReducer from "./employeeReducer";
import employmentReducer from "./employmentReducer";
import jobProfileReducer from "./jobProfileReducer";
import jointPowersReducer from "./jointPowersReducer";
import authenticationReducer from "./authenticationReducer";
import organizationReducer from "./organizationReducer";

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['*']
}

const rootReducer = combineReducers({
    contract: contractReducer,
    employee: employeeReducer,
    employment: employmentReducer,
    jobProfile: jobProfileReducer,
    jointPower: jointPowersReducer,
    authentication: authenticationReducer,
    organization: organizationReducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export default persistedReducer;